(() => {
  if (window.__triveniProductSliderReady) return;
  window.__triveniProductSliderReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-triveni-slider-button]');
    if (!button) return;
    const section = button.closest('[data-triveni-product-slider]');
    const track = section?.querySelector('[data-triveni-slider-track]');
    if (!track) return;
    const direction = button.dataset.triveniSliderButton === 'next' ? 1 : -1;
    track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
  });
})();
